import { createSelector } from 'reselect';
import { type StoreState } from '../types/StoreState';
import { selectGooglePayDto, selectGooglePayOptions } from './googlePay';

export const selectLoadPaymentMethodsState = (state: StoreState) => state.requestsState.loadPaymentMethods;
export const selectLoadPayPalScriptState = (state: StoreState) => state.requestsState.loadPayPalScript;
export const selectRequestStateApCanMakePayments = (state: StoreState) => state.requestsState.canMakePayments;
export const selectRequestStateApHighestVersion = (state: StoreState) =>
  state.requestsState.highestSupportedApplePayVersion;

export const selectIsAppDataLoaded = createSelector(
  selectLoadPaymentMethodsState,
  selectGooglePayDto,
  selectGooglePayOptions,
  (loadPaymentMethodsRequestState, googlePayPM, googlePayPMOptions) => {
    if (loadPaymentMethodsRequestState === 'fulfilled') {
      if (googlePayPM) {
        return googlePayPMOptions.loading === 'fulfilled' || googlePayPMOptions.loading === 'rejected';
      }
      return true;
    }
    return false;
  },
);
